export default {
      id: "i-card-recive-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/sprite.svg#i-card-recive",
      toString: function () {
        return this.url;
      }
    }